import { createContext } from 'react';
import { ICategory, TCategoryType } from 'types';

export type TSortBy =
	| ''
	| 'CustomerA-Z'
	| 'CustomerZ-A'
	| 'CategoriesA-Z'
	| 'CategoriesZ-A'
	| 'CategoryTypeA-Z'
	| 'CategoryTypeZ-A';
export type TCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow = null | 'toConfirmDeleteItem' | 'success' | 'error';
export interface IFilterValues {
	searchString: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	IDsSelectedCategoryTypes: TCategoryType[];
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
}

export interface ICategoryState {
	categories: ICategory;
	searchString: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	IDsSelectedCategoryTypes: TCategoryType[];
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const categoryInitialState: ICategoryState = {
	categories: { categoriesCount: 0, categories: [] },
	searchString: '',
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	IDsSelectedCategoryTypes: [],
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	typeOfModalWindow: null,
};

export interface ICategoryContext extends ICategoryState {
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	setIDCustomer(value: Nullable<string>): void;
	setIDRestaurant(value: Nullable<string>): void;
	setIDsSelectedCategoryTypes(value: TCategoryType[]): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TSortBy): void;
	setCountOfItems(count: TCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const CategoryContext = createContext<ICategoryContext>({
	deleteSelectedItem: async () => undefined,
	changeSearchString: () => undefined,
	setIDCustomer: () => undefined,
	setIDRestaurant: () => undefined,
	setIDsSelectedCategoryTypes: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...categoryInitialState,
});
